if (!customElements.get("custom-plyr")) {
    customElements.define("custom-plyr", class CustomPlyr extends HTMLElement {
        constructor() {
            super();
            this.config = JSON.parse(this.getAttribute("data-config"));
            this.mainPlyr = this.querySelector("[data-plyr]");
            this.player = null;
        }

        connectedCallback() {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.player = new Plyr(this.mainPlyr, this.config);
                        observer.disconnect();
                    }
                });
            }, {
                threshold: 0.1
            });

            observer.observe(this);
        }
    });
}